import PropTypes from 'prop-types';
import styles from './gradientDivider.module.scss';

export default function GradientDivider({ className = '' }) {
  return (
    <hr
      aria-hidden="true"
      className={`${styles.divider} ${className}`.trim()}
    />
  );
}

GradientDivider.propTypes = {
  className: PropTypes.string,
};
